import React, { useEffect, useState } from "react";
import * as R from "ramda";
import { Row, Card, CardHeader, CardBody } from "reactstrap";
import Drawer from "@material-ui/core/Drawer";
import { useSelector, useDispatch } from "react-redux";
import { push } from "connected-react-router";
import generateAction from "../../../../utils/action-helpers";
import { USER } from "../../../../state/actions";
import UsersTable from "./users";
import AddEditForm from "./add-edit-form";
import Loader from "../../../ui/loader";
import ErrorPage from "../../../ui/error";
import errorRed from "../../../../assets/img/error-red.png";

import "../css/index.scss";
import TooltipButton from "../../../ui/tooltip-button";

const Users = () => {
  const { all: users, loading, error, current } = useSelector(state => state.user);
  const [openedDrawer, setOpenedDrawer] = useState(false);

  const dispatch = useDispatch();

  useEffect(() => {
    if (current.role !== "Admin") {
      dispatch(push("/"));
    } else if (!loading && !error && (!users || R.isEmpty(users))) {
      dispatch(generateAction(USER.FETCH));
    }
  }, [loading, error, dispatch, users, current.role]);

  if (error)
    return (
      <ErrorPage
        title="Ha habido un error"
        subtitle="Oopps. Ha habido gestionando usuarios"
        text="Recargue la página y si el error persiste contacte con el CSU"
        image={errorRed}
        email={current.email}
        role={current.role}
      />
    );

  if (loading || !users || R.isEmpty(users)) return <Loader />;
  const AddUserButton = (
    <TooltipButton
      buttonClassName="btn-tool-table"
      onClick={() => setOpenedDrawer(true)}
      tooltipText="Crear nuevo usuario"
      iconClassName="icono-plus-filled"
    />
  );
  return (
    <Row>
      <div className="col-12">
        <Card className="mt-sm-3">
          <CardHeader className="d-flex align-items-center justify-content-between">
            <Row>
              <div className="col-12 mb-2">
                <h3>Gestión de usuarios</h3>
              </div>
            </Row>
          </CardHeader>
          <CardBody className="pt-0">
            <UsersTable data={users} extraToolbarOptions={AddUserButton} />
          </CardBody>
        </Card>
      </div>
      <Drawer className="sidebar-container" open={openedDrawer} variant="persistent" anchor="right">
        <AddEditForm close={() => setOpenedDrawer(false)} users={users} />
      </Drawer>
      {openedDrawer && <div className="sidebar-back fade show" />}
    </Row>
  );
};

export default Users;
